import { render, staticRenderFns } from "./KitaOrSchuleSelect.vue?vue&type=template&id=02b985ed&scoped=true&"
import script from "./KitaOrSchuleSelect.vue?vue&type=script&lang=js&"
export * from "./KitaOrSchuleSelect.vue?vue&type=script&lang=js&"
import style0 from "./KitaOrSchuleSelect.vue?vue&type=style&index=0&id=02b985ed&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b985ed",
  null
  
)

export default component.exports